import axios from 'axios'
import { TypedCustomer, TypedStock } from 'entities/shop/interface'

export const getCustomers = async (params: object) => {
  return await axios.get<TypedCustomer[]>('v2/my_customer_address_book', { params })
}
export const addCustomers = async (params: object) => {
  return await axios.post<TypedCustomer[]>('v2/my_customer_address_book', { params })
}
